import { render, staticRenderFns } from "./WaypointHoverAddButtons.vue?vue&type=template&id=28df09d0"
import script from "./WaypointHoverAddButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./WaypointHoverAddButtons.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports